import { makeAutoObservable } from "mobx";
import { IRMACounter } from "../../../services/api/dashboard-service";

class RmaCounterStore {

    constructor(private _model: IRMACounter) {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get name(): string { return this._model.name; }
    public get link(): string { return this._model.link; }
    public get count(): number { return this._model.count; }
}

export default RmaCounterStore;